var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor"},[_c('div',{ref:"toolbar",staticClass:"toolbar"}),_c('div',{ref:"editor",staticClass:"editor-text"}),(_vm.isShow)?_c('p',{staticStyle:{"color":"red","text-align":"right"}},[_vm._v(" 编辑内容不能超过"+_vm._s(_vm.config.limitNum)+"个字 ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }